import { PAYMENT_SELECT_METHOD } from './index';
import { Action } from '../action';

export class PaymentSelectMethodInitAction implements Action {
	readonly type = PAYMENT_SELECT_METHOD.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class PaymentSelectMethodDestroyAction implements Action {
	readonly type = PAYMENT_SELECT_METHOD.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class PaymentSelectMethodSelectMethodAction implements Action {
	readonly type = PAYMENT_SELECT_METHOD.SELECT_METHOD;
	constructor(
		public payload: string,
		public correlationId?: number
	) {}
}
